<template>
  <ThemeECommerceContainerSection
    :see-more-path="getPath({ componentName: 'Gallery' })"
    :menu-code="MENU_CODE.GALLERY"
    :title="modelValue.title"
    :description="modelValue.description"
    event-name=""
    category-event-name=""
  >
    <ThemeECommerceDisplayGallery
      :items="modelValue.content.slice(0,8)"
      class="tw-hidden md:tw-block"
      action-event-name="Preview - Home"
      fb-event-name="Gallery - Home"
      event-name="home"
    />
    <ThemeECommerceDisplayGallery
      :items="modelValue.content.slice(0,9)"
      class="tw-block md:tw-hidden"
      action-event-name="Preview - Home"
      fb-event-name="Gallery - Home"
      event-name="home"
    />
  </ThemeECommerceContainerSection>
</template>

<script lang="ts" setup>
import { MENU_CODE } from '~/constants/menu'

defineProps({
  modelValue: {
    type: Object as () => HomeSection<GalleryMeta[]>,
    required: true,
  },
})
const { getPath } = useNavigationMenu()
</script>
